import { put, call } from 'redux-saga/effects';
import * as productsActions from '../actions/productsActions';

export function* getAvailableProducts(api, action) {
  const response = yield call(api.getAvailableProducts, { page: 1, elementsPerPage: 10 });
  if (response.status == 200) {
    yield put(productsActions.saveAvailableProducts(response.data));
  }
}
